import React from 'react';
import { RUNTIME_URI } from '../../constants';

import '../../../css/flow/flow-tile.less';

const FlowTile = ({ flow, onClickDeleteFlow, onClickEditFlow, tenantId }) => (
    <div className="flow-tile">

        <header className="flow-tile-header">
            <h5>{ flow.developerName }</h5>

            <button className="btn btn-sm btn-nobackground" onClick={() => onClickDeleteFlow(flow)} title="Delete Flow">
                <span className="glyphicon glyphicon-trash" />
            </button>
        </header>

        <main className="flow-tile-content">
            { flow.developerSummary }
        </main>

        <footer className="flow-tile-footer">
            <button 
                className="btn btn-default"
                onClick={() => onClickEditFlow(flow)}
            >
                <span className="glyphicon glyphicon-pencil" />
                <span>Edit Flow</span>
            </button>

            <a 
                className="btn btn-success"
                href={`${RUNTIME_URI}/${tenantId}/play/default?flow-id=${flow.id.id}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                <span className="glyphicon glyphicon-play" />
                <span>Run</span>
            </a>
        </footer>
    </div>
);

export default FlowTile;
